import { render } from "./Header.vue?vue&type=template&id=b4638c9e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=b4638c9e&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4638c9e"]])

export default __exports__